import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { MediaMatcher } from "@angular/cdk/layout";
import { BehaviorSubject, Subscription } from "rxjs";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";

import { environment } from "src/environments/environment";
import { EnumLocationCategories, EnumLocationCategoriesSpanish } from "src/app/features/shared/helpers/enums/EnumLocationCategories";
import { LocationCategoryDTO } from "../../../../models/LocationCategoryDTO";
import { LocationsMapService } from "../../../../services/LocationsMap.service";
import { PanelDetailLocationsService } from "../../../../services/Panel-Detail-Locations.service";
import { AllowedDTO } from "src/app/features/pages/maps/utils/models/allowedDTO";

@Component({
  selector: "panel-detail-locations",
  templateUrl: "./panel-detail-locations.component.html",
  styleUrls: ["./panel-detail-locations.component.css"],
})
export class PanelDetailLocationsComponent implements OnInit, OnDestroy {
  
  fullScreen: boolean = false;

  enumLocationCategories = EnumLocationCategories;
  enumLocationCategoriesSpanish = EnumLocationCategoriesSpanish;
  enumLocationCategoriesValues: string[];
  enumLocationCategoriesValuesSpanish: string[];
  isVisibleDetails: boolean;
  categorySelected: LocationCategoryDTO;
  itWorksAsVirtualLocationCategory: boolean = false;
  openCarDetails: boolean = false;
  openServiceDetails: boolean = false;
  openEngineerDetails: boolean = false;
  openProspectDetails: boolean = false;
  openGenericDetails: boolean = false;
  openGenericVirtualDetails: boolean = false;


  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();
  $categorySelected: Observable<number> = new Observable<number>();

  suscription_categorySelected: Subscription;
  suscription_getLoading: Subscription;
  suscription_isVisibleDetails: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private panelDetalilService: PanelDetailLocationsService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private locationsMapService: LocationsMapService,
    private localStorageService: LocalStorageService,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 769px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.enumLocationCategoriesValues = Object.values(this.enumLocationCategories).map(value => value.toLowerCase());
    this.enumLocationCategoriesValuesSpanish = Object.values(this.enumLocationCategoriesSpanish).map(value => value.toLowerCase());
    this.$categorySelected = this.panelDetalilService.getCategorySelected();
    this.suscription_categorySelected = this.$categorySelected.subscribe((element) => {
      // this.categorySelected = element;
      if(!environment.production) console.log("categorySelected", element, this.isVisibleDetails);
      if (this.localStorageService.getListaCategorias() !== null && !!element && element > -1) {
        const listaCategorias = JSON.parse(this.localStorageService.getListaCategorias());
        this.categorySelected = listaCategorias.find((category: any) => category.id == element);

        this.itWorksAsVirtualLocationCategory = this.categorySelected != null && this.categorySelected.itWorksAsVirtualLocation;

        this.selectDetailsPanel();
      }
    });
    this.suscription_getLoading = this.panelDetalilService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

    this.suscription_isVisibleDetails = this.panelDetalilService.checkVisibilityPopup().subscribe((data: boolean) => {
      this.isVisibleDetails = data;
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.suscription_categorySelected) {
      this.suscription_categorySelected.unsubscribe();
    }
    if (this.suscription_getLoading) {
      this.suscription_getLoading.unsubscribe();
    }
    if (this.suscription_isVisibleDetails) {
      this.suscription_isVisibleDetails.unsubscribe();
    }
  }

  CancelButton(){
    if (this.locationsMapService.locationsubscription) {
      this.locationsMapService.locationsubscription.unsubscribe();
    }
    this.categorySelected = null;
    this.itWorksAsVirtualLocationCategory = false;

    this.panelDetalilService.setLoading(false);
    this.panelDetalilService.setVisibilityPopup(false);
  }

  selectDetailsPanel(){
    this.openGenericVirtualDetails = false;
    this.openCarDetails = false;
    this.openServiceDetails = false;
    this.openEngineerDetails = false;
    this.openGenericDetails = false;
    this.openProspectDetails = false;
    if (this.itWorksAsVirtualLocationCategory) {
      switch (this.categorySelected?.name.toLowerCase()) {
        case EnumLocationCategories.Service.toLowerCase():
          this.openServiceDetails = true;
          break;
        case EnumLocationCategories.Prospect.toLowerCase():
          this.openProspectDetails = true;
          break;
        default:
          this.openGenericVirtualDetails = true;
          break;
      }
    }else{
      switch (this.categorySelected?.name.toLowerCase()) {
        case EnumLocationCategories.Car.toLowerCase():
          this.openCarDetails = true;
          break;
        case EnumLocationCategories.Service.toLowerCase():
          this.openServiceDetails = true;
          break;
        case EnumLocationCategories.Engineer.toLowerCase():
          this.openEngineerDetails = true;
          break;
        case EnumLocationCategories.Prospect.toLowerCase():
          this.openProspectDetails = true;
          break;
        default:
          this.openGenericDetails = true;
          break;
      }
    }
  }

  
}
